module.exports = __webpack_public_path__ + "static/media/think-out-of-the-box.10de7bfb.md";